<template>
    <div class="flex justify-end text-right leading-7"
        :class="{ 'pb-2 border-b border-primary-dark': store.form.fields.value.ticket.ticket.requires_deposit === 1 }">
        <table class="text-primary-dark table--alt">
            <tr class="hidden">
                <td class="px-2">
                    <span> Subtotal: </span>
                </td>

                <td class="px-2">
                    <span class="text-secondary" data-basket-grand-total> price </span>
                </td>
            </tr>

            <tr class="hidden">
                <td class="px-2">
                    <span> VAT @ 20%: </span>
                </td>

                <td class="px-2">
                    <span class="text-secondary" data-order-grand-total>
                        <code> price </code>
                    </span>
                </td>
            </tr>

            <tr>
                <td class="px-2">
                    <strong> Total: </strong>
                </td>

                <td class="px-2">
                    <strong class="text-secondary">
                        &pound;{{ totalCost }}
                    </strong>
                </td>
            </tr>
        </table>
    </div>

    <div class="" v-if="store.form.fields.value.ticket.ticket.requires_deposit === 1">
        <div class="flex justify-end text-right leading-7">
            <table class="text-primary-dark table--alt">
                <tr>
                    <td class="px-2">
                        <strong> Deposit amount: </strong>
                    </td>

                    <td class="px-2">
                        <strong class="text-secondary">
                            &pound; {{ totalDeposit }}
                        </strong>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script setup>
    import store from "@app/booking/state/store.js"
    import { computed } from "vue"

    const totalTicketCost = computed(() => store.form.fields.value.ticket.ticket.cheapest_price.total_price * store.form.fields.value.ticket.quantity)
    const totalOptionCost = computed(
        () => store.form.fields.value.options.reduce(
            (price, option) => price + (option.cheapest_price.total_price * store.form.fields.value.ticket.quantity),
            0
        )
    )


    const totalCost = computed(() => totalTicketCost.value + totalOptionCost.value)
    const totalDeposit = computed(() => store.form.fields.value.ticket.ticket.cheapest_price.deposit * store.form.fields.value.ticket.quantity)
</script>